import IncomeChart from './IncomeChart';

export default IncomeChart;
